import { useState } from 'react';
import styles from './custom-switch.module.scss';
import { ActiveType } from './custom-switch.types';

interface CustomSwitchProps {
  initialActive: ActiveType;
  onSwitch: (active: ActiveType) => void;
  className?: string;
}

export default function CustomSwitch({
  initialActive = 'Calls',
  onSwitch,
  className,
}: CustomSwitchProps) {
  const [active, setActive] = useState<ActiveType>(initialActive);

  const handleSwitch = (type: ActiveType) => {
    setActive(type);
    if (onSwitch) {
      onSwitch(type);
    }
  };

  return (
    <div className={`${styles.switchContainer} ${className}`}>
      <button
        type="button"
        className={`${styles.switchButton} ${active === 'Calls' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('Calls')}
      >
        Calls
      </button>
      <button
        type="button"
        className={`${styles.switchButton} ${active === 'SMS' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('SMS')}
      >
        SMS
      </button>
    </div>
  );
}
